import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { GetStateList } from "../../../utilities";

const initialState = {
    states: [{
        name: "",
        code: ""
    }]
}

export const GetStates = createAsyncThunk("States/GetStates", () => GetStateList())

const StateListSlice = createSlice({
    name: "States",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder

            .addCase(GetStates.fulfilled, (state, action: PayloadAction<any>) => {
                state.states = action.payload.data
            })

    }
})

export default StateListSlice.reducer